/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_$i as $i,
  rec_Bo as Bo,
  rec_Componente_bZ_98_90 as Componente_bZ_98_90,
  rec_Componente_xZ_120_90 as Componente_xZ_120_90,
  rec_Componente_yZ_121_90 as Componente_yZ_121_90,
  rec_DX as DX,
  rec_EstadoError as EstadoError,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_SelectorFecha as SelectorFecha,
  rec_SelectorMultiple as SelectorMultiple,
  rec_YX as YX,
  rec_aZ as aZ,
  rec_api as api,
  rec_iZ as iZ,
  rec_oZ as oZ,
  rec_sZ as sZ,
  rec_zo as zo,
} from "../../runtime/index.jsx";
import { HistorialTransporte } from "../transporte/HistorialTransporte.jsx";
export function PedidosMovilidadAdmin() {
  let e = Go(),
    [t, n] = (0, React.useState)(() => oZ(7)),
    [r, i] = (0, React.useState)(aZ),
    [a, o] = (0, React.useState)(iZ),
    [s, c] = (0, React.useState)(iZ),
    [l, u] = (0, React.useState)(iZ),
    [f, p] = (0, React.useState)(``),
    [m, h] = (0, React.useState)([]),
    [g, _] = (0, React.useState)(!0),
    [v, y] = (0, React.useState)(``),
    b = (0, React.useCallback)(async () => {
      _(!0);
      try {
        let e = l === iZ ? `` : `&estado=${l}`;
        (h(await api(`/transporte/pedidos?desde=${t}&hasta=${r}${e}`)), y(``));
      } catch (e) {
        y(e.message);
      } finally {
        _(!1);
      }
    }, [t, r, l]);
  (0, React.useEffect)(() => {
    b();
  }, [b]);
  let x = (0, React.useMemo)(() => {
      let e = f.trim().toLowerCase();
      return m.filter((t) =>
        (a !== iZ && t.sede !== a) || (s !== iZ && t.area !== s)
          ? !1
          : !e ||
            [t.destino, t.solicitante, t.codigo, t.sede, t.area]
              .filter(Boolean)
              .some((t) => t.toLowerCase().includes(e)),
      );
    }, [m, a, s, f]),
    S = (0, React.useMemo)(
      () => [...new Set(m.map((e) => e.sede).filter(Boolean))].sort(),
      [m],
    ),
    C = (0, React.useMemo)(
      () => [...new Set(m.map((e) => e.area).filter(Boolean))].sort(),
      [m],
    ),
    w = (0, React.useMemo)(() => {
      let e = x.reduce((e, t) => e + (t.personas || 0), 0),
        t = x.filter((e) => e.estado === `PENDIENTE`).length;
      return {
        pedidos: x.length,
        personas: e,
        pendientes: t,
      };
    }, [x]);
  function T() {
    if (x.length === 0) {
      e.info(`No hay pedidos para llevar a Excel con esos filtros`);
      return;
    }
    let n = x.map((e) => ({
        Código: e.codigo,
        Fecha: sZ(e.fecha),
        Salida: e.salida,
        Fundo: e.sede,
        Personas: e.personas,
        Área: e.area ?? ``,
        Destino: e.destino,
        "Lo pidió": e.solicitante,
        Teléfono: e.telefono,
        Estado: e.estado,
        "Motivo de cancelación": e.motivoCancelacion ?? ``,
      })),
      i = YX.json_to_sheet(n),
      a = YX.book_new();
    (YX.book_append_sheet(a, i, `Movilidad`),
      DX(a, `movilidad-${t}-a-${r}.xlsx`),
      e.ok(`Archivo descargado`));
  }
  return (
    <div
      className={`flex flex-col gap-4`}
      children={[
        <EstadoError mensaje={v} onReintentar={b} />,
        <section
          className={`${Bo} flex flex-col gap-3`}
          children={[
            <div
              className={`grid grid-cols-2 gap-3 sm:grid-cols-5`}
              children={[
                <label
                  className={`flex flex-col gap-1 text-sm text-(--text)`}
                  children={[
                    `Desde`,
                    <SelectorFecha value={t} onChange={n} max={r} />,
                  ]}
                />,
                <label
                  className={`flex flex-col gap-1 text-sm text-(--text)`}
                  children={[
                    `Hasta`,
                    <SelectorFecha value={r} onChange={i} min={t} />,
                  ]}
                />,
                <label
                  className={`flex flex-col gap-1 text-sm text-(--text)`}
                  children={[
                    `Fundo`,
                    <SelectorMultiple
                      value={a}
                      onChange={o}
                      opciones={[
                        {
                          value: iZ,
                          label: `Todas`,
                        },
                        ...S.map((e) => ({
                          value: e,
                          label: e,
                        })),
                      ]}
                    />,
                  ]}
                />,
                <label
                  className={`flex flex-col gap-1 text-sm text-(--text)`}
                  children={[
                    `Área`,
                    <SelectorMultiple
                      value={s}
                      onChange={c}
                      opciones={[
                        {
                          value: iZ,
                          label: `Todas`,
                        },
                        ...C.map((e) => ({
                          value: e,
                          label: e,
                        })),
                      ]}
                    />,
                  ]}
                />,
                <label
                  className={`flex flex-col gap-1 text-sm text-(--text)`}
                  children={[
                    `Estado`,
                    <SelectorMultiple
                      value={l}
                      onChange={u}
                      opciones={[
                        {
                          value: iZ,
                          label: `Todos`,
                        },
                        {
                          value: `PENDIENTE`,
                          label: `Sin atender`,
                        },
                        {
                          value: `EN_ORDEN`,
                          label: `En una orden`,
                        },
                        {
                          value: `CANCELADA`,
                          label: `Cancelados`,
                        },
                      ]}
                    />,
                  ]}
                />,
              ]}
            />,
            <div
              className={`flex flex-col gap-2 sm:flex-row sm:items-center`}
              children={[
                <input
                  type={`search`}
                  value={f}
                  onChange={(e) => p(e.target.value)}
                  placeholder={`Buscar por destino, persona o código`}
                  className={`${Lo} flex-1`}
                />,
                <button
                  type={`button`}
                  onClick={T}
                  className={zo}
                  children={`Llevar a Excel`}
                />,
              ]}
            />,
          ]}
        />,
        g ? (
          <Componente_bZ_98_90 />
        ) : v ? null : (
          <JSXRuntime.Fragment
            children={[
              <div
                className={`grid grid-cols-3 gap-3`}
                children={[
                  <Componente_yZ_121_90
                    etiqueta={`Pedidos`}
                    valor={w.pedidos}
                  />,
                  <Componente_yZ_121_90
                    etiqueta={`Personas`}
                    valor={w.personas}
                  />,
                  <Componente_yZ_121_90
                    etiqueta={`Sin atender`}
                    valor={w.pendientes}
                  />,
                ]}
              />,
              x.length === 0 ? (
                <Componente_xZ_120_90
                  texto={`No hay pedidos con esos filtros. Probá ampliando las fechas.`}
                />
              ) : (
                <JSXRuntime.Fragment
                  children={[
                    <ul
                      className={`flex flex-col gap-2 sm:hidden`}
                      children={x.map((e) => (
                        <li
                          key={e.id}
                          className={`${Bo} p-3`}
                          children={[
                            <div
                              className={`flex items-start justify-between gap-2`}
                              children={[
                                <div
                                  className={`min-w-0`}
                                  children={[
                                    <p
                                      className={`font-medium text-(--text-h)`}
                                      children={[e.salida, ` · `, e.sede]}
                                    />,
                                    <p
                                      className={`truncate text-sm text-(--text)`}
                                      children={e.destino}
                                    />,
                                  ]}
                                />,
                                <span
                                  className={`flex shrink-0 items-center gap-1 text-sm font-medium text-(--text-h)`}
                                  children={[
                                    (0, JSXRuntime.jsx)($i, {
                                      className: `h-4 w-4`,
                                      "aria-hidden": `true`,
                                    }),
                                    e.personas,
                                  ]}
                                />,
                              ]}
                            />,
                            e.area && (
                              <p
                                className={`mt-1 text-xs font-medium text-(--text-h)`}
                                children={e.area}
                              />
                            ),
                            <p
                              className={`mt-1 text-xs text-(--text)`}
                              children={[
                                sZ(e.fecha),
                                ` · lo pidió `,
                                e.solicitante,
                                ` · `,
                                e.codigo,
                              ]}
                            />,
                          ]}
                        />
                      ))}
                    />,
                    <div
                      className={`${Bo} hidden overflow-x-auto sm:block`}
                      children={
                        <table
                          className={`w-full text-left text-sm`}
                          children={[
                            <thead
                              className={`text-(--text)`}
                              children={
                                <tr
                                  children={[
                                    <th
                                      className={`py-2 pr-3 font-medium`}
                                      children={`Fecha`}
                                    />,
                                    <th
                                      className={`py-2 pr-3 font-medium`}
                                      children={`Salida`}
                                    />,
                                    <th
                                      className={`py-2 pr-3 font-medium`}
                                      children={`Fundo`}
                                    />,
                                    <th
                                      className={`py-2 pr-3 font-medium`}
                                      children={`Personas`}
                                    />,
                                    <th
                                      className={`py-2 pr-3 font-medium`}
                                      children={`Área`}
                                    />,
                                    <th
                                      className={`py-2 pr-3 font-medium`}
                                      children={`Destino`}
                                    />,
                                    <th
                                      className={`py-2 pr-3 font-medium`}
                                      children={`Lo pidió`}
                                    />,
                                    <th
                                      className={`py-2 pr-3 font-medium`}
                                      children={`Código`}
                                    />,
                                  ]}
                                />
                              }
                            />,
                            <tbody
                              className={`text-(--text-h)`}
                              children={x.map((e) => (
                                <tr
                                  key={e.id}
                                  className={`border-t border-(--border)`}
                                  children={[
                                    <td
                                      className={`py-2 pr-3 whitespace-nowrap`}
                                      children={sZ(e.fecha)}
                                    />,
                                    <td
                                      className={`py-2 pr-3 whitespace-nowrap`}
                                      children={e.salida}
                                    />,
                                    <td
                                      className={`py-2 pr-3`}
                                      children={e.sede}
                                    />,
                                    <td
                                      className={`py-2 pr-3`}
                                      children={e.personas}
                                    />,
                                    <td
                                      className={`py-2 pr-3`}
                                      children={e.area ?? `—`}
                                    />,
                                    <td
                                      className={`py-2 pr-3`}
                                      children={e.destino}
                                    />,
                                    <td
                                      className={`py-2 pr-3`}
                                      children={e.solicitante}
                                    />,
                                    <td
                                      className={`py-2 pr-3 text-(--text)`}
                                      children={[
                                        <div className={`whitespace-nowrap`} children={e.codigo} />,
                                        <span className={`mt-0.5 inline-block rounded-full px-2 py-0.5 text-[10px] ${e.estado === `CANCELADA` ? `bg-(--error-bg) text-(--error)` : e.estado === `EN_ORDEN` ? `bg-(--success-bg) text-(--success)` : `bg-(--warning-bg) text-(--warning-texto)`}`}
                                          children={e.estado === `CANCELADA` ? `Cancelado` : e.estado === `EN_ORDEN` ? `En orden` : `Sin atender`} />,
                                        e.motivoCancelacion && <div className={`text-[11px] text-(--error)`} children={e.motivoCancelacion} />,
                                        <HistorialTransporte de={`pedido`} id={e.id} />,
                                      ]}
                                    />,
                                  ]}
                                />
                              ))}
                            />,
                          ]}
                        />
                      }
                    />,
                  ]}
                />
              ),
            ]}
          />
        ),
      ]}
    />
  );
}
